import { ModuleItemType } from '@app/store/shared';

export type LearningPortfolioNoteType = 'text' | 'voice' | 'file' | 'reflection' | 'assessment_submission';

export const READONLY_NOTE_TYPES: LearningPortfolioNoteType[] = ['reflection', 'assessment_submission'];

export const UNDELETABLE_NOTE_TYPES: LearningPortfolioNoteType[] = ['reflection'];

export type LearningPortfolioSource = 'course' | 'standalone';

export interface LearningPortfolioTextPayloadDto {
    title: string;
    content: string | null;
}

export type LearningPortfolioPayloadDto = LearningPortfolioTextPayloadDto;

export interface LearningPortfolioContextDto {
    pathwayId?: string;
    pathwayName?: string;
    courseId?: string;
    courseName?: string;
    moduleId?: string;
    moduleName?: string;
    itemId?: string;
    itemType?: ModuleItemType;
    itemName?: string;
}

export interface LearningPortfolioCategoryDto {
    id: string;
    name: string;
    system: boolean;
    assignable: boolean;
}

export interface LearningPortfolioAttachmentDto {
    id: string;
    filename: string;
    url: string;
}

export interface LearningPortfolioNoteListDto {
    items: LearningPortfolioNoteDto[];
    total: number; // total matching items, ignoring pagination
}

export interface LearningPortfolioNoteDto {
    id: string;
    type: LearningPortfolioNoteType;
    payload: LearningPortfolioPayloadDto;
    categories: LearningPortfolioCategoryDto[];
    context: LearningPortfolioContextDto | null;
    attachments: LearningPortfolioAttachmentDto[];
    createdAt: number;
    updatedAt: number;
}
